import React, { useState, useMemo } from 'react';

import { useWindowStore, useConfigStore } from '../../stores';
import SiteSeeContext from '../SiteSeeGuides/SiteSeeContext';

import Map from '../Map/Map';
import SiteSeeGuides from '../SiteSeeGuides/SiteSeeGuides';

const SiteSeePage = () => {
  const [ siteSeeGuideId, setSiteSeeGuideId ] = useState( null );
  const [ showSiteSeeGuide, setShowSiteSeeGuide ] = useState( false );
  const [ siteSeeGuideMode, setSiteSeeGuideMode ] = useState( null );
  const [ siteSeeModalDims, setSiteSeeModalDims ] = useState( [] );

  const isMobile = useWindowStore((state) => state.isMobile);
  const config = useConfigStore((state) => state.config);
  const { siteSeeName = 'Virtual Visit' } = config || {};
  const actionWord = isMobile ? 'Tap' : 'Click';

  const contextMemo = useMemo( () => ( {
    siteSeeGuideId,
    setSiteSeeGuideId,
    showSiteSeeGuide,
    setShowSiteSeeGuide,
    siteSeeGuideMode,
    setSiteSeeGuideMode,
    siteSeeModalDims,
    setSiteSeeModalDims,
    siteSeeName,
    actionWord,
    isMobile,
  } ), [
    siteSeeGuideId,
    setSiteSeeGuideId,
    showSiteSeeGuide,
    setShowSiteSeeGuide,
    siteSeeGuideMode,
    setSiteSeeGuideMode,
    siteSeeModalDims,
    setSiteSeeModalDims,
    siteSeeName,
    actionWord,
    isMobile,
  ] );

  return (
    <SiteSeeContext.Provider
      value={contextMemo}
    >
      <div className="map">

        <Map />

        <SiteSeeGuides />

      </div>
    </SiteSeeContext.Provider>
  );
};

export default SiteSeePage;
